import NavBlogCard from './NavBlogCard';

export default NavBlogCard;
